import * as React from 'react';
import DocumentTitle from '../../../misc/components/DocumentTitle';
import SpirometryAnalysisSetListTable from "./SpirometryAnalysisSetListTable";
import {
    QueryOrderDirection, Permission, User,
} from "../../../misc/api/apiTypes";
import { useQueryTable, ClearFiltersAction, QueryTableState, QueryTableActions } from "../../../misc/components/queryTable/Hooks/UseQueryTable";
import { CreateAnalysisBatchModal } from '../../QC/CreateAnalysisBatchModal';
import { Authorization } from '../../../misc/components/Authorization';
import { PermissionEnum } from '../../../misc/api/ApiPermissionEnum';
import { MainState } from '../../../Core/reducers';
import { connect } from 'react-redux';
import { useCurrentStudyConfigurationContext } from '../../../Core/CurrentStudyConfigurationContext';
import { SessionTypes } from '../../../misc/api/ApiSessionTypes';
import { useSecurityContext } from '../../../Core/SecurityContext';

export interface SpirometryAnalysisSetListScreenProps {
    currentUser: User;
}

export interface SpirometryAnalysisSetListScreenOwnProps {
    queryTableReducer: [QueryTableState, React.Dispatch<QueryTableActions>];
}

export const SpirometryAnalysisSetListScreen = ({ currentUser, queryTableReducer }: SpirometryAnalysisSetListScreenProps & SpirometryAnalysisSetListScreenOwnProps): JSX.Element => {
    const [qcSelectionModalVisible, setQCSelectionModelVisible] = React.useState(false);
    const [qcBatchSaved, setQcBatchSaved] = React.useState<boolean | undefined>(undefined);
    const { study } = useCurrentStudyConfigurationContext();
    const { currentUserPermissions } = useSecurityContext();

    const [_, dispatch] = queryTableReducer;

    const clearAllFilters = () => {
        dispatch(ClearFiltersAction.create());
    };

    const handleQcBatchSavingAlertMessage = () => {
        if (qcBatchSaved) {
            return (<div className="row">
                        <div className="col-md-12">
                            <div className="alert alert-success">
                                <i className="fa fa-check icon"></i>
                                QC batch is created successfully.
                            </div>
                        </div>  
                    </div>);
        }
        else if (qcBatchSaved === false) {
            return (<div className="row">
                        <div className="col-md-12">
                            <div className="alert alert-danger">
                                <i className="fa fa-times icon"></i>
                                There was an error. QC batch wasn't saved.
                            </div>
                        </div>  
                    </div>);
        }
        else {
            return null
        }
    }

    return (
        <DocumentTitle title="Spirometry Analysis Sets | Vitalograph Web Portal">
            <div className="row">
                <div className="col-md-6">
                    <h2 className="text-primary">FVC Analysis Sets</h2>
                </div>
                <div className="col-md-6">
                    <div className="h2 pull-right">
                        <button className="btn btn-primary" onClick={clearAllFilters}>Clear All Filters</button>&nbsp;
                        <Authorization studyId={study.id} currentPermissions={currentUserPermissions} permissionId={PermissionEnum.CreateAutomatedQCFvcSelection}>
                            <button className="btn btn-primary" onClick={() => setQCSelectionModelVisible(true)}>Create QC Batch</button>
                        </Authorization>
                    </div>
                </div>
            </div>
            {handleQcBatchSavingAlertMessage()}
            <div className="row">
                <div className="col-md-12">
                    <div className="ibox">
                        <div className="ibox-content">
                            <div className="table-responsive">
                                <SpirometryAnalysisSetListTable queryTableReducer={queryTableReducer} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {qcSelectionModalVisible ? <CreateAnalysisBatchModal currentUser={currentUser} sessionType={SessionTypes.Fvc} minimumTests={3} onSave={(result: boolean) => setQcBatchSaved(result)} onClose={() => setQCSelectionModelVisible(false)} /> : null}
        </DocumentTitle>
    );
};

const mapStateToProps = (state: MainState): SpirometryAnalysisSetListScreenProps => {
    return {
        currentUser: state.security.currentUser,
    };
}

export default connect<SpirometryAnalysisSetListScreenProps>(mapStateToProps)(SpirometryAnalysisSetListScreen);
